import {useEffect, useState} from "react"

import Lottie from "lottie-react"
import animateCar from "./animations/car.json"
import animateLeaf from "./animations/leaf.json"
import animateBalloon from "./animations/balloon.json"
import animateHouse from "./animations/house.json"
import animateChristmas from "./animations/christmas.json"
import animateChristmasBounce from "./animations/christmas_bounce.json"


export const AnimateCar = ({styles}) => {
    const [style, setStyle] = useState({
        position: "absolute",
        zIndex: -1,
        width: "90%",
        right: 0,
        opacity: 0.7,
    })

    useEffect(() => {
        if (styles)
            setStyle({
                ...style,
                ...styles
            })
    }, [styles])

    return (
        <div className={"lottie-bg"} style={style}>
            <Lottie animationData={animateCar}
                    loop={true}
                    autoplay={true}
                    style={{width: "100%", height: style?.height ?? "800px"}}
            />
        </div>
    )
}

export const AnimateBalloon = () => {
    const style = {
        position: "absolute",
        zIndex: 0,
        width: "100%",
        height: "100%",
        left: 0,
        right: 0,
        marginLeft: "auto",
        marginRight: "auto",
        overflow: "hidden",
        opacity: 0.1,
    }

    return (
        <div className={"lottie-bg"} style={style}>
            <Lottie animationData={animateBalloon}
                    loop={true}
                    autoplay={true}
                // style={{width: "100%", height: "100%", left: 0, right: 0, position: "absolute"}}
            />
        </div>
    )

}

export const AnimateLeaf = () => {
    const style = {
        position: "absolute",
        zIndex: 0,
        width: "100%",
        height: "100%",
        right: 0,
        margin: "auto",
    }

    return (
        <div style={style}>
            <Lottie animationData={animateLeaf}
                    loop={true}
                    autoplay={true}
                    style={{width: "100%", height: "100%"}}
            />
        </div>
    )
}

export const AnimateHouse = () => {
    const style = {}

    return (
        <div style={style}>
            <Lottie animationData={animateHouse}
                    loop={true}
                    autoplay={true}
                    style={{width: "100%", height: "100%"}}
            />
        </div>
    )
}

export const AnimateChristmas = () => {
    const style = {
        width: "100%",
    }

    return (
        <div style={style}>
            <Lottie animationData={animateChristmas}
                    loop={true}
                    autoplay={true}
                    style={{width: "100%", height: "100%"}}
            />
        </div>
    )
}

export const AnimateChristmasBounce = () => {
    const style = {
        position: "absolute",
        height: "100%",
        top: 0,
        left: 0,
        right: 0,
        overflow: "hidden",
        opacity: 0.3,
        zIndex: -2,
    }

    return (
        <div style={style}>
            <Lottie animationData={animateChristmasBounce}
                    loop={false}
                    autoplay={true}
                    style={{width: "100%", height: "100%"}}
            />
        </div>
    )
}

